import React from 'react'
import { Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
   container: {
       padding: '20px',
       marginBottom: '10px'
   },
   noteContainer: {
       padding: '20px',
       backgroundColor: '#F0F2F9',
       display: 'flex'
   }
}))

export default function TextInfoBox() {
    const classes = useStyles()

    return (
        <Paper className={classes.container}>
            <div className={classes.noteContainer}>
                <Typography variant="h6">Note</Typography>
                <ul>
                    <li><Typography>If no destinationIDs are setup for any Zones in the Project then all new isochrones generated after configuring the destinationID for the Zone will be based on the time brackets saved here. </Typography></li>
                    <li><Typography>If the Time brackets are being updated for an already configured and active Tempo enabled project the isochrones will only be updated on next refresh, within the next 6 months.</Typography></li>
                    <li><Typography>If you wish to regenerate the isochrones immediately for an already configured and active Tempo enabled project, please contact the Engineering team to assist you with it.</Typography></li>
                </ul>
            </div>
        </Paper>
    )
}